import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

export const toggleFavourite = createAsyncThunk(
  'mealPlan/toggleFavourite',
  async ({ id = "", category = "", meal, activeTab = "" }, { dispatch }) => {
    dispatch(toggleFavouriteOptimistically(meal));
    try {
      await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/toggle-favorite-meal`, {
        id: id,
        category: category
      });
      if (activeTab == 'favourite') {
        var p = {'category':'favourite','term':'','page':1,'perPage':10};
        dispatch(fetchAddMealList(p));
      }
    } catch (error) {
      dispatch(toggleFavouriteOptimisticallyRollback(meal));
      throw error;
    }
  }
);

export const fetchAddMealList = createAsyncThunk(
  'mealPlan/fetchAddMealList',
  async ({ category = "", term = "", page = 1, perPage = 10  }) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/get-add-meal-list`, {
      category:category,
      term:term,
      page:page,
      perPage:10
    });
    return response.data;
  }
);

export const fetchMealPlanData = createAsyncThunk(
  'mealPlan/fetchMealPlanData',
  async () => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/get-meal-plan-data?origin=web`);
    return response.data.data;
  }
);

export const deleteFavouriteMealPlan = createAsyncThunk(
  'favouriteMealPlan/deleteFavouriteMealPlan',
  async (planId) => {
    const response = await api.delete(`${process.env.REACT_APP_API_BASE_URL}/customer/favourite-meal-plan/${planId}`);
    return response.data;
  }
);

export const chooseFavouriteMealPlan = createAsyncThunk(
  'favouriteMealPlan/chooseFavouriteMealPlan',
  async (choosedId) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/favourite-meal-plan/choose`, {
      choosed_id: choosedId,
    });
    return response.data;
  }
);

export const fetchFavouriteMealPlans = createAsyncThunk(
  'favouriteMealPlan/fetchFavouriteMealPlans',
  async () => {
    const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/customer/favourite-meal-plan?page=1`);
    return response.data.data;
  }
);

export const editFavouriteMealPlan = createAsyncThunk(
  'favouriteMealPlan/editFavouriteMealPlan',
  async ({ planId, title }) => {
    const response = await api.put(`${process.env.REACT_APP_API_BASE_URL}/customer/favourite-meal-plan/${planId}`, {
      title: title,
    });
    return response.data;
  }
);

export const addMealToNutritionPlan = createAsyncThunk(
  'favouriteMealPlan/addMealToNutritionPlan',
  async ({ id, category }, { dispatch }) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/add-meal-to-nutrition-plan`, {
      id: id,
      category: category,
    });
    dispatch(fetchMealPlanData());
    return response.data;
  }
);

export const deleteMeal = createAsyncThunk('mealPlan/deleteMeal', async ({ mealId ,meal, category=''}, { dispatch }) => { 
  dispatch(deleteOnUi( { mealId,meal,category }));
  try {
      await api.delete(`${process.env.REACT_APP_API_BASE_URL}/customer/delete-meal-plan-data/${mealId}`);
    } catch (error) {
      dispatch(fetchMealPlanData());
      throw error;
    }
});

export const startNewDay = createAsyncThunk('mealPlan/startNewDay', async (_, { dispatch }) => {
  await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/start-a-new-day`);
  dispatch(fetchMealPlanData());
  return 1;
});

export const fetchMealItemDetail = createAsyncThunk(
  'mealPlan/fetchMealItemDetail',
  async (mealId) => {
    const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/customer/get-item-detail/${mealId}`);
    return response.data.data;
  }
);

export const fetchIngredientsForCustomize = createAsyncThunk(
  'mealPlan/fetchIngredientsForCustomize',
  async ({ term, page }) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/get-ingredients-list-for-customize?page=`+page, {
      term:term,
      page:page
    });
    return response.data.data;
  }
);

export const addIngredientToMealPlan = createAsyncThunk(
  'mealPlan/addIngredientToMealPlan',
  async (ingredientData) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/add-ingredient-to-meal-admin`, ingredientData);
    return response.data;
  }
);

export const deleteIngredientFromMealPlan = createAsyncThunk(
  'mealPlan/deleteIngredientFromMealPlan',
  async ({ mealId, deleteIndex }, { dispatch }) => {
    await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/delete-ingredient-from-meal-admin`, {
      mealId,
      deleteIndex,
    });
    dispatch(fetchMealItemDetail(mealId));
    return { mealId, deleteIndex };
  }
);

export const updateIngredientQuantity = createAsyncThunk(
  'mealPlan/updateIngredientQuantity',
  async ({ mealId, deleteIndex, quantity }, { dispatch }) => {
    await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/update-ingredient-quantity-admin`, {
      mealId:mealId,
      index:deleteIndex,
      quantity:quantity
    });
    dispatch(fetchMealItemDetail(mealId));
    return { mealId, deleteIndex };
  }
);


export const addFavouriteNutritionPlan = createAsyncThunk(
  'mealPlan/addFavouriteNutritionPlan',
  async ({title}, { dispatch }) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/add-favourite-nutrition-plan`, {
      title:title
    });
    dispatch(clearMessage());
    return response.data; 
  }
);

const mealPlanSlice = createSlice({
  name: 'mealPlan',
  initialState: {
    mealPlans: [],
    addMealList: [],
    customizeMealList: [],
    addMealListCurrentPage: 1,
    addMealListTotalPages: 1,
    errorMessage: '',
    successMessage:'',
    data: {},
    mealDetail: null,
    status: 'idle',
    customizeMealListCurrentPage:1,
    customizeMealListTotalPages:1,
    newly_added_nutrition_plans_meal:''
  },
  reducers: {    
    deleteOnUi: (state, action) => {
      state.data[action.payload.category.toLowerCase()+'_nutrition_plans'] = action.payload.meal;
    },
    toggleFavouriteOptimistically: (state, action) => {     
      state.addMealList = action.payload; 
    },
    toggleFavouriteOptimisticallyRollback: (state, action) => {
      const updatedMealPlans = state.mealPlans.map(meal => 
        meal.id === action.payload.id 
        ? { ...meal, favourite: !meal.favourite }
        : meal
      );
      state.mealPlans = updatedMealPlans;
    },
    clearMessage: (state, action) => {
      state.successMessage = '';
      state.errorMessage = '';
      state.newly_added_nutrition_plans_meal = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavouriteMealPlans.fulfilled, (state, action) => {
        state.mealPlans = action.payload;
      })
      .addCase(fetchFavouriteMealPlans.rejected, (state, action) => {
        state.errorMessage = '';
      })
      .addCase(fetchAddMealList.fulfilled, (state, action) => {
        state.addMealList = action.payload.data.data;
        state.addMealListCurrentPage = action.payload.data.current_page;
        state.addMealListTotalPages = action.payload.data.last_page;
      })    
      .addCase(fetchIngredientsForCustomize.fulfilled, (state, action) => {
        state.customizeMealList = action.payload.data;
        state.customizeMealListCurrentPage = action.payload.current_page || 1;
        state.customizeMealListTotalPages = action.payload.last_page;
      })
      .addCase(fetchIngredientsForCustomize.rejected, (state, action) => {
        state.errorMessage = '';
      })  
      .addCase(fetchAddMealList.rejected, (state, action) => {
        state.errorMessage = '';
      })
      .addCase(chooseFavouriteMealPlan.fulfilled, (state) => {
        state.errorMessage = '';
      })
      .addCase(addMealToNutritionPlan.fulfilled, (state, action) => {
        state.newly_added_nutrition_plans_meal = action.payload.data.newly_added_nutrition_plans_meal;
        state.errorMessage = '';
      })
      .addCase(editFavouriteMealPlan.fulfilled, (state) => {
        state.errorMessage = '';
      })
      .addCase(deleteFavouriteMealPlan.fulfilled, (state) => {
        state.errorMessage = '';
      })
      .addCase(deleteFavouriteMealPlan.rejected, (state, action) => {
        state.errorMessage = action.error.message;
      })
      .addCase(fetchMealPlanData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchMealPlanData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchMealPlanData.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(deleteMeal.pending, (state, action) => {
        state.successMessage = '';
        state.errorMessage = '';
      })
      .addCase(deleteMeal.fulfilled, (state, action) => {
        const mealId = action.payload;
        state.successMessage = '';
        state.errorMessage = '';
      })
      .addCase(startNewDay.fulfilled, (state) => {
        state.errorMessage = '';
      })
      .addCase(fetchMealItemDetail.fulfilled, (state, action) => {
        state.mealDetail = action.payload;
      })
      .addCase(fetchMealItemDetail.rejected, (state, action) => {
        state.errorMessage = action.error.message;
      })
      .addCase(addIngredientToMealPlan.fulfilled, (state) => {
        state.errorMessage = '';
      })
      .addCase(deleteIngredientFromMealPlan.fulfilled, (state, action) => {
      })
      .addCase(updateIngredientQuantity.fulfilled, (state, action) => {
      })     

      .addCase(toggleFavourite.fulfilled, (state, action) => {
      })
      .addCase(addFavouriteNutritionPlan.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
  },
});
export const { toggleFavouriteOptimistically, toggleFavouriteOptimisticallyRollback, deleteOnUi, clearMessage } = mealPlanSlice.actions;
export default mealPlanSlice.reducer;